import { render } from "./QrCode.vue?vue&type=template&id=ac0f64f2&scoped=true&ts=true"
import script from "./QrCode.vue?vue&type=script&lang=ts"
export * from "./QrCode.vue?vue&type=script&lang=ts"

import "./QrCode.vue?vue&type=style&index=0&id=ac0f64f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0f64f2"]])

export default __exports__